import { z } from 'zod'
import { httpUrlSchema } from './url.js'

// .trim() sur la clé (absent du schéma d'origine envisagé) : un copier-coller
// depuis un e-mail Planity laisse facilement un espace ou un retour à la
// ligne final. Sans trim, min(1) l'accepterait tel quel et le widget
// recevrait une clé invalide sans qu'aucune erreur ne s'affiche ici — cf.
// practicalInfoSchema, qui applique la même précaution aux champs texte
// libres (adresse, téléphone) pour la même raison. planityPublicUrl n'a pas
// ce traitement, par cohérence avec les autres champs d'URL du projet
// (mapsUrl, socialLink.url), jamais trimmés.
export const bookingSettingsSchema = z.object({
  planityWidgetKey: z.string().trim().min(1, 'La clé du widget est obligatoire'),
  planityPublicUrl: httpUrlSchema,
})

export type BookingSettings = z.infer<typeof bookingSettingsSchema>

// Valeurs autrefois en dur dans chaque page embarquant le module Planity,
// où la clé était recopiée à l'identique.
export const DEFAULT_BOOKING_SETTINGS: BookingSettings = {
  planityWidgetKey: '-MmNxEmEfwgR5sqRSHw2',
  planityPublicUrl: 'https://www.planity.com/azoya-spa-89290-auxerre',
}
